// Ski mask storefront behaviour. Every widget is opt-in through a data attribute, so sections stay plain Liquid.
(() => {
  const pad = (n) => String(n).padStart(2, '0');

  // Sale countdown: only runs against a real end date set in the theme editor, and hides itself once it passes.
  document.querySelectorAll('[data-m-countdown]').forEach((bar) => {
    const end = Date.parse(bar.dataset.mCountdown);
    if (!end) return bar.remove();
    const cells = bar.querySelectorAll('[data-unit]');
    const tick = () => {
      let left = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (!left) return bar.remove();
      const parts = { d: Math.floor(left / 86400), h: Math.floor(left / 3600) % 24, m: Math.floor(left / 60) % 60, s: left % 60 };
      cells.forEach((c) => (c.firstChild.textContent = pad(parts[c.dataset.unit])));
      bar.hidden = false;
    };
    tick();
    setInterval(tick, 1000);
  });

  // Delivery timeline: today, then business-day ranges for dispatch and delivery.
  const addBusinessDays = (date, days) => {
    const d = new Date(date);
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) days--;
    }
    return d;
  };
  const ordinal = (n) => n + (['th', 'st', 'nd', 'rd'][(n % 100 > 10 && n % 100 < 14) || n % 10 > 3 ? 0 : n % 10]);
  const fmt = (d) => `${d.toLocaleDateString('en-US', { month: 'short' })} ${ordinal(d.getDate())}`;
  document.querySelectorAll('[data-m-timeline]').forEach((el) => {
    const [p1, p2, s1, s2] = el.dataset.mTimeline.split(',').map(Number);
    const now = new Date();
    const range = (a, b) => (a === b ? fmt(addBusinessDays(now, a)) : `${fmt(addBusinessDays(now, a))} – ${fmt(addBusinessDays(now, b))}`);
    el.querySelector('[data-day=ordered]').textContent = fmt(now);
    el.querySelector('[data-day=ready]').textContent = range(p1, p2);
    el.querySelector('[data-day=delivered]').textContent = range(p1 + s1, p2 + s2);
  });

  // Rotating quotes under the buy button.
  document.querySelectorAll('[data-m-quotes]').forEach((box) => {
    const quotes = [...box.children];
    if (quotes.length < 2) return;
    let i = 0;
    setInterval(() => {
      quotes[i].hidden = true;
      i = (i + 1) % quotes.length;
      quotes[i].hidden = false;
    }, 5000);
  });

  // Before / after slider.
  document.querySelectorAll('[data-m-slider]').forEach((s) => {
    const input = s.querySelector('input');
    const set = () => s.style.setProperty('--pos', input.value + '%');
    input.addEventListener('input', set);
    set();
  });

  // Product form: gallery, style buttons, bundle tiers, add to cart, sticky bar.
  document.querySelectorAll('[data-m-product]').forEach((root) => {
    const data = JSON.parse(root.querySelector('[data-m-json]').textContent);
    const money = (cents) => {
      const v = (cents / 100).toFixed(2);
      return data.moneyFormat.replace(/\{\{\s*amount(_with_comma_separator)?\s*\}\}/, (_, comma) => (comma ? v.replace('.', ',') : v)).replace(/\{\{.*?\}\}/, v);
    };

    const main = root.querySelector('[data-m-main]');
    root.querySelectorAll('[data-m-thumb]').forEach((btn) => {
      btn.addEventListener('click', () => {
        root.querySelectorAll('[data-m-thumb]').forEach((b) => b.setAttribute('aria-current', b === btn));
        main.src = btn.dataset.mThumb;
        main.srcset = '';
        main.alt = btn.querySelector('img').alt;
      });
    });
    // Swipe the main image left/right to step through the thumbnails; mostly-vertical drags still scroll the page.
    const thumbs = [...root.querySelectorAll('[data-m-thumb]')];
    const stage = main && main.closest('.m-gallery__main');
    if (stage && thumbs.length > 1) {
      let x0 = null, y0 = 0;
      stage.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        const i = Math.max(0, thumbs.findIndex((b) => b.getAttribute('aria-current') === 'true'));
        const next = thumbs[(i + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length];
        next.click();
        next.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }, { passive: true });
    }

    const showVariantImage = (id) => {
      const v = data.variants.find((x) => x.id == id);
      const thumb = v && v.image && root.querySelector(`[data-m-thumb][data-media="${v.image}"]`);
      if (thumb) thumb.click();
    };

    // Style buttons set every unit picker in every tier, so the simple path is one tap.
    const styleBtns = root.querySelectorAll('[data-m-style]');
    const styleName = root.querySelector('[data-m-style-name]');
    styleBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        styleBtns.forEach((b) => b.setAttribute('aria-pressed', b === btn));
        if (styleName) styleName.textContent = btn.textContent.trim();
        root.querySelectorAll('[data-m-unit]').forEach((sel) => (sel.value = btn.dataset.mStyle));
        showVariantImage(btn.dataset.mStyle);
      });
    });
    root.querySelectorAll('[data-m-unit]').forEach((sel) => sel.addEventListener('change', () => showVariantImage(sel.value)));

    // Express checkout takes one variant and a quantity, so it follows the selected tier and hides for mixed styles.
    const express = root.querySelector('[data-m-express]');
    const mixedNote = root.querySelector('[data-m-express-mixed]');
    const syncExpress = (ids, qty) => {
      if (!express) return;
      const mixed = new Set(ids).size > 1;
      express.hidden = mixed;
      if (mixedNote) mixedNote.hidden = !mixed;
      if (ids.length) express.querySelector('[data-m-express-id]').value = ids[0];
      express.querySelector('[data-m-express-qty]').value = qty;
    };

    const tiers = root.querySelectorAll('[data-m-tier]');
    if (tiers.length && !root.querySelector('[data-m-tier] input:checked')) tiers[0].querySelector('input').checked = true;
    const stickyPrice = root.querySelector('[data-m-sticky-price]');
    const paint = () => {
      tiers.forEach((t) => {
        const qty = +t.dataset.qty, off = +t.dataset.off;
        const ids = [...t.querySelectorAll('[data-m-unit]')].map((s) => s.value);
        const full = ids.reduce((sum, id) => sum + (data.variants.find((v) => v.id == id)?.price || data.price), 0) || data.price * qty;
        const total = Math.round(full * (1 - off / 100));
        t.querySelector('[data-total]').textContent = money(total);
        t.querySelector('[data-each]').textContent = money(Math.round(total / qty));
        const was = t.querySelector('[data-was]');
        if (was) was.textContent = off ? money(full) : '';
        if (t.querySelector('input').checked) {
          if (stickyPrice) stickyPrice.textContent = money(total);
          syncExpress(ids, qty);
        }
      });
    };
    root.addEventListener('change', paint);
    styleBtns.forEach((b) => b.addEventListener('click', paint));
    paint();

    const error = root.querySelector('[data-m-error]');
    const add = async (btn) => {
      const tier = root.querySelector('[data-m-tier] input:checked')?.closest('[data-m-tier]');
      const ids = tier ? [...tier.querySelectorAll('[data-m-unit]')].map((s) => s.value) : [data.variants[0].id];
      const items = Object.entries(ids.reduce((acc, id) => ((acc[id] = (acc[id] || 0) + 1), acc), {})).map(([id, quantity]) => ({ id: +id, quantity }));
      btn.disabled = true;
      error.hidden = true;
      try {
        const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) throw new Error((await res.json()).description || 'Could not add to cart');
        window.location.href = data.afterAdd;
      } catch (e) {
        error.textContent = e.message;
        error.hidden = false;
        btn.disabled = false;
      }
    };
    root.querySelectorAll('[data-m-add]').forEach((btn) => btn.addEventListener('click', () => add(btn)));

    const sticky = root.querySelector('[data-m-sticky]');
    const anchor = root.querySelector('[data-m-add]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(anchor);
    }
  });
})();
